<div *accessRoles="MANAGE_USERS">

  <div class="page-header">Manage User </div>
  <ng-table [rows]="rows" [columns]="columns" (cellClicked)="showUserDetail($event)">
  </ng-table>
  <div class="row form-group">
    <div class="col-md-3 ml-auto">
      <button class="btn btn-lg btn-greengo btn-block" (click)="showCreateUser()">Add new user</button>
    </div>
  </div>

  <div [hidden]="addNewUserHidden">
    <form class="add-new-user clearfix" [formGroup]="newUserForm">
      <div class="col-12 col-md-4 px-0">
        <h4 class="details-title ">New User </h4>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 mx-auto">
          <div class="form-group">
            <div class="title">
              <mat-form-field [ngClass]="{
                'is-valid': newUserForm.get('title').valid && newUserForm.get('title').touched && !ipTitle.isFocus,
                'is-invalid': !newUserForm.get('title').valid && newUserForm.get('title').touched && !ipTitle.isFocus
              }">
                <mat-select formControlName="title" placeholder="Title" npDetectFocus #ipTitle="detectFocus">
                  <mat-option *ngFor="let item of selectTitle" [value]="item">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="error-message" *ngIf="!newUserForm.get('title').valid && newUserForm.get('title').touched && !ipTitle.isFocus">
                Please input information here
              </div>
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-valid': newUserForm.get('firstName').valid && newUserForm.get('firstName').touched && !ipFN.isFocus,
              'is-invalid': !newUserForm.get('firstName').valid && newUserForm.get('firstName').touched && !ipFN.isFocus
            }">
              <input matInput type="text" name="firstName" formControlName="firstName" placeholder="First name" npDetectFocus #ipFN="detectFocus" maxlength="255">
            </mat-form-field>
            <div class="error-message" *ngIf="newUserForm.get('firstName').hasError('required') && newUserForm.get('firstName').touched && !ipFN.isFocus">
              Please input information here
            </div>
            <div class="error-message"
              *ngIf="newUserForm.get('firstName').hasError('pattern') && newUserForm.get('firstName').touched && !ipFN.isFocus">
              {{ commonMessage.ruleForUserNameField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-valid': newUserForm.get('middleName').valid && newUserForm.get('middleName').touched && !ipMD.isFocus,
              'is-invalid': !newUserForm.get('middleName').valid && newUserForm.get('middleName').touched && !ipMD.isFocus
            }">
              <mat-label>Middle name</mat-label>
              <input matInput type="text" name="middleName" formControlName="middleName" npDetectFocus #ipMD="detectFocus" maxlength="255">
            </mat-form-field>
            <div class="error-message"
              *ngIf="!newUserForm.get('middleName').valid && newUserForm.get('middleName').touched && !ipMD.isFocus">
              {{ commonMessage.ruleForUserNameField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-valid': newUserForm.get('lastName').valid && newUserForm.get('lastName').touched && !ipLN.isFocus,
              'is-invalid': !newUserForm.get('lastName').valid && newUserForm.get('lastName').touched && !ipLN.isFocus
            }">
              <input matInput type="text" name="lastName" id="" formControlName="lastName" placeholder="Last name" npDetectFocus #ipLN="detectFocus" maxlength="255">
            </mat-form-field>
            <div class="error-message" *ngIf="newUserForm.get('lastName').hasError('required') && newUserForm.get('lastName').touched && !ipLN.isFocus">
              Please input information here
            </div>
            <div class="error-message"
              *ngIf="newUserForm.get('lastName').hasError('pattern') && newUserForm.get('lastName').touched && !ipLN.isFocus">
              {{ commonMessage.ruleForUserNameField }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field [ngClass]="{
              'is-valid': newUserForm.get('email').valid && newUserForm.get('email').touched && !ipEmail.isFocus,
              'is-invalid': !newUserForm.get('email').valid && newUserForm.get('email').touched && !ipEmail.isFocus
            }">
              <input matInput type="email" class="email" formControlName="email" [readonly]="partnerId" placeholder="Email" npDetectFocus
                #ipEmail="detectFocus">
            </mat-form-field>
            <div class="error-message" *ngIf="newUserForm.get('email').hasError('required') && newUserForm.get('email').touched && !ipEmail.isFocus">
              Please input information here
            </div>
            <div class="err-message" role="alert" *ngIf="newUserForm.get('email').hasError('email') && newUserForm.get('email').touched && !ipEmail.isFocus">
              Please enter valid email
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 px-0">
        <h4 class="details-title ">User permission</h4>
      </div>
      <div class="col-12 col-md-4 offset-md-4">
        <p>
          Please grant permission for user by tick on the checkbox(es) below:
        </p>
        <div class="col-12" *ngFor="let item of permissionList">
          <mat-checkbox (change)="item.checked = !item.checked" [checked]="item.checked" class="greengo">
            {{item.displayName}}
          </mat-checkbox>
        </div>
        <div class="col-12 my-3 px-0">
          <button type="submit" class="btn btn-block btn-lg" (click)="addNewUser()" [ngClass]="{
            'btn-greengo': newUserForm.valid,
            'btn-inactive': !newUserForm.valid
          }" npFocusOutClicked>Save</button>
        </div>
      </div>
    </form>

  </div>
</div>